import { render } from "./DeclineOrderModification.vue?vue&type=template&id=3204e34f"
import script from "./DeclineOrderModification.vue?vue&type=script&lang=js"
export * from "./DeclineOrderModification.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__